import { useState } from "react";
import { useNavigate } from "react-router-dom";

const carImages = [
  "https://readdy.ai/api/search-image?query=Buick%20GL8%20MPV%20white%20luxury%20business%20van%20side%20front%20view%20clean%20background%20automotive%20photography%20professional%20high%20quality&width=375&height=220&seq=921&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Buick%20GL8%20interior%20luxury%20seats%20modern%20comfortable%20business%20van%20cabin%20clean%20professional%20car%20interior%20photography&width=375&height=220&seq=922&orientation=landscape",
];

const specs = [
  ["车型", "别克 GL8 商务7座"],
  ["座位", "7座"],
  ["变速箱", "自动"],
  ["排量", "2.0T"],
  ["燃油", "汽油"],
  ["里程限制", "不限里程"],
];

const services = [
  { icon: "ri-shield-check-line", label: "全险保障", color: "#10B981" },
  { icon: "ri-user-line", label: "专属司机", color: "#1E3A8A" },
  { icon: "ri-gas-station-line", label: "油费自理", color: "#F59E0B" },
  { icon: "ri-time-line", label: "准时接送", color: "#6366F1" },
];

export default function CarDetailPage() {
  const navigate = useNavigate();
  const [imgIdx, setImgIdx] = useState(0);

  return (
    <div className="min-h-screen pb-[calc(env(safe-area-inset-bottom,0px)+96px)]" style={{ background: "#F8F9FC", fontFamily: "'Inter','SF Pro Text',sans-serif" }}>
      {/* Image */}
      <div className="relative" style={{ height: 220 }}>
        <img src={carImages[imgIdx]} alt="car" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, transparent 40%)" }} />
        <button onClick={() => navigate(-1)} className="absolute top-12 left-5 w-9 h-9 flex items-center justify-center rounded-full cursor-pointer" style={{ background: "rgba(255,255,255,0.9)" }}>
          <i className="ri-arrow-left-line" style={{ fontSize: 20, color: "#374151" }} />
        </button>
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
          {carImages.map((_, i) => (
            <button key={i} onClick={() => setImgIdx(i)}
              className="rounded-full cursor-pointer"
              style={{ width: i === imgIdx ? 16 : 6, height: 6, background: i === imgIdx ? "#fff" : "rgba(255,255,255,0.5)" }} />
          ))}
        </div>
      </div>

      {/* Booked banner */}
      <div className="px-5 py-3 flex items-center gap-2" style={{ background: "#EFF6FF" }}>
        <i className="ri-checkbox-circle-fill" style={{ color: "#1E3A8A", fontSize: 18 }} />
        <span className="text-sm font-semibold" style={{ color: "#1E3A8A" }}>已预订</span>
        <span className="text-xs text-gray-500">· 取车时间：2025-05-01 14:00</span>
      </div>

      <div className="px-5 py-4 space-y-4">
        {/* Trip info */}
        <div className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.04)" }}>
          <div className="text-base font-bold text-gray-800 mb-3">别克 GL8 商务7座</div>
          <div className="space-y-2">
            {[
              { icon: "ri-map-pin-line", label: "取车地点", value: "三亚凤凰国际机场" },
              { icon: "ri-time-line", label: "取车时间", value: "2025-05-01 14:00" },
              { icon: "ri-map-pin-2-line", label: "还车地点", value: "三亚凤凰国际机场" },
              { icon: "ri-time-line", label: "还车时间", value: "2025-05-05 12:00" },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-3 py-2 border-b border-gray-50 last:border-0">
                <div className="w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0" style={{ background: "#EFF6FF" }}>
                  <i className={item.icon} style={{ color: "#1E3A8A", fontSize: 14 }} />
                </div>
                <span className="text-xs text-gray-400 w-16 flex-shrink-0">{item.label}</span>
                <span className="text-sm font-medium text-gray-700">{item.value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Specs */}
        <div className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.04)" }}>
          <div className="text-sm font-semibold text-gray-800 mb-3">车辆配置</div>
          <div className="grid grid-cols-3 gap-3">
            {specs.map(([k, v]) => (
              <div key={k} className="px-3 py-2 rounded-xl text-center" style={{ background: "#F8F9FC" }}>
                <div className="text-xs text-gray-400 mb-0.5">{k}</div>
                <div className="text-xs font-semibold text-gray-700">{v}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Services */}
        <div className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.04)" }}>
          <div className="text-sm font-semibold text-gray-800 mb-3">服务说明</div>
          <div className="grid grid-cols-2 gap-3">
            {services.map((s) => (
              <div key={s.label} className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl" style={{ background: "#F8F9FC" }}>
                <div className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0" style={{ background: `${s.color}15` }}>
                  <i className={s.icon} style={{ color: s.color, fontSize: 16 }} />
                </div>
                <span className="text-xs font-medium text-gray-700">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Insurance */}
        <div className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.04)" }}>
          <div className="text-sm font-semibold text-gray-800 mb-2">保险详情</div>
          <div className="space-y-1.5">
            {["第三者责任险（100万）", "车辆损失险（含自然灾害）", "人员意外险（每座20万）", "盗抢险"].map((item) => (
              <div key={item} className="flex items-center gap-2 text-xs text-gray-600">
                <i className="ri-check-line" style={{ color: "#10B981", fontSize: 14 }} />
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom button */}
      <div className="fixed bottom-0 left-0 right-0 bg-white px-5 pt-4" style={{ boxShadow: "0 -4px 16px rgba(0,0,0,0.06)", paddingTop: "16px", paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))" }}>
        <button onClick={() => navigate(-1)}
          className="w-full flex items-center justify-center gap-2 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer transition-all active:scale-95"
          style={{ height: 48, background: "#F3F4F6", color: "#374151" }}>
          <i className="ri-arrow-left-line" />
          返回订单
        </button>
      </div>
    </div>
  );
}
